import { httpClient } from './httpClient';

const base = '/api/empresas';

export const listarEmpresas = () => httpClient.get(base);
export const obtenerEmpresa = (id) => httpClient.get(`${base}/${id}`);
export const crearEmpresa = (payload) => httpClient.post(base, payload);
export const actualizarEmpresa = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarEmpresa = (id) => httpClient.del(`${base}/${id}`);

const empresasService = {
  listar: listarEmpresas,
  obtener: obtenerEmpresa,
  crear: crearEmpresa,
  actualizar: actualizarEmpresa,
  eliminar: eliminarEmpresa,
};

export default empresasService;
